import fourOFour from '~frontend-common/images/404.svg';
import childSurprise from '~frontend-common/images/child-surprise.svg';
import cookies from '~frontend-common/images/cookies.svg';
import handwave from '~frontend-common/images/handwave.svg';
import logoCheck from '~frontend-common/images/logo-check.svg';
import logo from '~frontend-common/images/logo.svg';

import giftPurple from '../assets/images/gift-purple.svg';
import notificationsEmptyPurple from '../assets/images/notifications-empty-purple.svg';
import notificationsFullPurple from '../assets/images/notifications-full-purple.svg';

export const Images = {
  error: {
    fourOfour: fourOFour,
    unknown: childSurprise,
  },
  header: {
    incognito: cookies,
    logo: logo,
    logoCheck: logoCheck,
    // TODO: add loader for non-svg
    notSupported: '/img/common/logo-in-box.png',
    referral: giftPurple,
    notificationsEmpty: notificationsEmptyPurple,
    notificationsFull: notificationsFullPurple,
  },
  policies: {
    handWave: handwave,
  },
};
